module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/202-taiwan-6743df2a5172e17e011314d12d1380ba.svg";